import ASignup from "./Signup.vue";
import { UnAuthorizedLayout } from "~/components";

new Vue({
    delimiters: ["[[", "]]"],
    el: "#signup_layout",
    components: {
        ASignup,
        UnAuthorizedLayout,
    },
});
